import { mapWidgetElementsBookingElementButtonStylesFromDto } from "@/elements/widget/elements/booking-element/button/styles/widget-elements-booking-element-button-styles.mapper";
import {
  type WidgetElementsBookingElementButton,
  type WidgetElementsBookingElementButtonDto,
} from "@/elements/widget/elements/booking-element/button/widget-elements-booking-element-button";

export const mapWidgetElementsBookingElementButtonFromDto = (
  widgetElementsBookingElementButtonDto: WidgetElementsBookingElementButtonDto,
): WidgetElementsBookingElementButton => ({
  position: {
    x: widgetElementsBookingElementButtonDto.position.x,
    y: widgetElementsBookingElementButtonDto.position.y,
  },
  animation: {
    type: widgetElementsBookingElementButtonDto.animation.type,
  },
  styles: mapWidgetElementsBookingElementButtonStylesFromDto(
    widgetElementsBookingElementButtonDto.styles,
  ),
  shouldAutoInject: widgetElementsBookingElementButtonDto.shouldAutoInject,
});
